import DesignTokens from '@tableau/design-tokens';
import { OperationsPlusIcon } from '@tableau/icons/OperationsPlusIcon';
import {
  ButtonType,
  ButtonWidget
} from '@tableau/widgets';
import React from 'react';

import { applyColor } from '~src/style/ColorService';

import { Messages } from '../../codegen/Localize';
import { AddNewPermissionStyles } from '../styles/AddNewPermissionStyle';

export type AddNewPermissionProps = AddNewPermissionStyles.AddNewPermissionContainerStyleArgs & {
  disabled: boolean;
  onClick: () => void;
};

export class AddNewPermission extends React.PureComponent<AddNewPermissionProps, {}>{
  public static readonly BUTTON_ID = 'add-new-permission-button';

  private getButtonContent = (): JSX.Element => {
    return (
      <span className={ AddNewPermissionStyles.ButtonContent }>
        <OperationsPlusIcon
          alt=''
          role={ 'presentation' }
          color={ applyColor(
            this.props.disabled ? DesignTokens.color.font.default.disabled : DesignTokens.color.font.default.secondary,
            this.props.disabled ? '#BFBFBF' : '#676767'
          ) }
          size={ 12 }
        />
        { Messages.permissionRuleAdd() }
      </span>
    );
  };

  public render() {
    const { numAddedRows, searching } = this.props;
    const containerClassName = AddNewPermissionStyles.memoizedButtonContainer({ numAddedRows, searching });
    return (
      <div className={ containerClassName }>
        <ButtonWidget
          buttonType={ ButtonType.Outline }
          disabled={ this.props.disabled }
          getContent={ this.getButtonContent }
          handleClick={ this.props.onClick }
          testId={ AddNewPermission.BUTTON_ID }
        />
      </div>
    );
  }
}
